export enum EDataLookupType {
  APNLookup = 'APN_LOOKUP',
  PropertyLookup = 'PROPERTY_LOOKUP',
}

export enum EDataLookupStatus {
  Requested = 'REQUESTED',
  Processing = 'PROCESSING',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}

export enum EDataLookupFileKind {
  Input = 'INPUT',
  Results = 'RESULTS',
  Audit = 'AUDIT',
}

export enum EPropertyLookupMode {
  Address = 'ADDRESS',
  ParcelNumber = 'PARCEL_NUMBER',
}

export enum EDataLookupBillingStatus {
  PaymentMethodCaptured = 'PAYMENT_METHOD_CAPTURED',
  Invoicing = 'INVOICING',
  Paid = 'PAID',
  PaymentFailed = 'PAYMENT_FAILED',
  NotCharged = 'NOT_CHARGED',
}

export interface IAPNLookupColumnMapping {
  address: string;
  city: string;
  state: string;
  zip: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

export interface IAPNLookupConfiguration {
  schemaVersion: 1;
  columnMapping: IAPNLookupColumnMapping;
}

export type IPropertyLookupColumnMapping = {
  address: string;
  city: string;
  state: string;
  zip: string;
} | {
  parcelNumber: string;
  zip: string;
};

export type IPropertyLookupConfiguration = {
  schemaVersion: 1;
  lookupMode: EPropertyLookupMode;
  columnMapping: IPropertyLookupColumnMapping;
};

export interface IDataLookupInvoiceSnapshot {
  id: string;
  number?: string;
  status?: string;
  createdAt: string;
  paidAt?: string;
  hostedInvoiceUrl?: string;
}

export interface IDataLookupBilling {
  estimatedAmount: number;
  billableRecordCount?: number;
  actualAmount?: number;
  billingStatus: EDataLookupBillingStatus;
  invoice?: IDataLookupInvoiceSnapshot;
}

export interface IDataLookupFile {
  _id: string;
  kind: EDataLookupFileKind;
  filename: string;
  contentType: string;
  byteSize: number;
  recordCount: number;
}

interface IDataLookupBase {
  _id: string;
  submittedBy: {
    _id: string;
    firstName?: string;
    lastName?: string;
    email?: string;
  };
  status: EDataLookupStatus;
  processingStartedAt?: string;
  completedAt?: string;
  inputFiles: IDataLookupFile[];
  outputFiles: IDataLookupFile[];
  inputRecordCount: number;
  processedRecordCount: number;
  outputRecordCount: number;
  failedRecordCount: number;
  duplicateRecordCount: number;
  billing?: IDataLookupBilling;
  createdAt: string;
  updatedAt: string;
}

export interface IAPNDataLookup extends IDataLookupBase {
  type: EDataLookupType.APNLookup;
  configuration: IAPNLookupConfiguration;
}

export interface IPropertyDataLookup extends IDataLookupBase {
  type: EDataLookupType.PropertyLookup;
  configuration: IPropertyLookupConfiguration;
  billing: IDataLookupBilling;
}

export type IDataLookup = IAPNDataLookup | IPropertyDataLookup;

export interface IDataLookupListResponse {
  data: IDataLookup[];
  pagination: { page: number; limit: number; total: number };
}
